/**
 * Layout metrics that both CSS and JavaScript need to agree on.
 *
 * The grid is virtualised, so the row height has to be known in JavaScript before a
 * row exists — but it is also declared in `tokens.css`, because layout is CSS's job.
 * Two sources of truth for the same number is exactly how a virtualised list ends up
 * misaligned by a few pixels per screen. A unit test reads the CSS and asserts these
 * constants match it, so the pair cannot drift.
 */

export const DICHTE = ["weit", "normal", "kompakt", "klassik"] as const;
export type Dichte = (typeof DICHTE)[number];

/** Must match `--row-h` per `[data-density]` in apps/web/src/styles/tokens.css. */
export const ROW_HEIGHT: Record<Dichte, number> = {
  weit: 32,
  normal: 28,
  kompakt: 24,
  klassik: 20,
};

/** Height of the sticky grid header. */
export const HEADER_HEIGHT = 30;

/** Height of the sticky totals row at the foot of a grid. */
export const TOTALS_HEIGHT = 30;

/**
 * Klassik cell width in pixels. IBM Plex Mono advances 0.6 em, so at the skin's
 * 13.3333 px size one character is exactly 8 px — which is what lets a 132-column
 * mask line up the way the printed Zinsliste does.
 */
export const K_CELL = 8;

export const K_COLS = 132;

/** How many rows to render beyond the viewport on each side while scrolling. */
export const OVERSCAN = 8;

export const SKINS = ["modern", "klassik"] as const;
export type Skin = (typeof SKINS)[number];

/** The density a skin defaults to when the user has not chosen one. */
export const DEFAULT_DICHTE: Record<Skin, Dichte> = {
  modern: "normal",
  klassik: "klassik",
};
